import React, { useState, useEffect } from 'react'
import AdminLayout from '../../AdminLayout'
import ContentHeader from '../../layout/ContentHeader'
import { CATEGORT_LIST, DELETE_CATEGORY } from '../../../../data/url';
import httpClient from '../../../../http/HttpRequest';
import { PRODUCT_STATUS } from '../../../../data/constant';
import TableLayout from '../../layout/TableLayout';
import Alert from '../../../../feature/Alert';
import FormLayout from '../../layout/FormLayout';

export default function CategoryList() {

    const [list, setCategoryData] = useState([]);

    const tableHeaders = ['#', 'name', 'desc', 'status', 'edit', 'delete'];

    const keys = ["category_name", "description", "status", "btnEdit", "btnDelete"];

    const btnData = {
        btnEdit: {
            name: "edit", link: "/root/product/updateCategory"
        },
        btnDelete: {
            name: "delete", method: deleteCategory
        }
    }

    useEffect(() => {
        categoryData();
    }, []);

    const categoryData = async (payload = {}) => {
        const res = await httpClient.post(CATEGORT_LIST, payload);
        if (res.requestStatus === "OK") {
            const result = res.result;
            if (result.status === 1) {
                setCategoryData(result.data);
            }
        }
    }

    const deleteRecord = async (id) => {
        const res = await httpClient.post(DELETE_CATEGORY, { category_id: id });
        if (res.requestStatus === "OK") {
            const result = res.result;
            if (result.status === 1) {
                categoryData();
                Alert.success(result.message);
            } else {
                Alert.error(result.message);
            }
        }
    }

    function deleteCategory(id) {
        deleteRecord(id);
    }

    const [formData, setFormData] = useState({
        formTitle: 'Search Customer',
        formFields: [
            { label: 'category', id: 'category', type: 'text', name: 'category_name', value: '', className: "col-md-3", placeholder: 'Enter category' },
        ],
        formErrors: { category_name: '' },
    });

    const handleFieldChange = (fieldName, value) => {
        setFormData((prevFormData) => {
            const updatedFormFields = prevFormData.formFields.map((field) =>
                field.name === fieldName ? { ...field, value: value } : field
            );
            return {
                ...prevFormData,
                formFields: updatedFormFields,
            };
        });
    }

    const handleFieldBlur = () => { }

    const handleSubmit = (e) => {
        e.preventDefault();
        let post = {};
        const updatedFormFields = formData.formFields.map((field) => {
            post[field.name] = field.value;
            return field;
        });
        setFormData((prevFormData) => ({
            ...prevFormData,
            formFields: updatedFormFields,
        }));
        categoryData(post);
    }

    return (
        <AdminLayout>
            <div className="content-wrapper">
                <ContentHeader
                    title="category"
                    newButton="new"
                    newButtonLink="root/product/actionCategory"
                />
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <FormLayout
                                formTitle={formData.formTitle}
                                formFields={formData.formFields}
                                formErrors={formData.formErrors}
                                onFieldChange={handleFieldChange}
                                onFieldBlur={handleFieldBlur}
                                onSubmit={handleSubmit}
                                isModal
                                search
                            />
                            <TableLayout
                                headers={tableHeaders}
                                keys={keys}
                                tableData={list}
                                id="category_id"
                                btnData={btnData}
                                statusKey="status"
                                statusObject={PRODUCT_STATUS}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    )
}
